<div class="ag-cell-label-container" role="presentation">
  <div
    ref="eLabel"
    class="ag-header-cell-label"
    role="presentation"
    unselectable="on"
  >
    <span
      ref="eText"
      class="ag-header-cell-text"
      role="columnheader"
      unselectable="on"
      aria-colindex="1"
      #menuButton
      [ngClass]="{
        active: activeFilter || activeSort
      }"
    >
      <!-- Sort asc-desc icons  -->
      <span
        class="ag-header-cell-text__sort"
        *ngIf="this.colDef.sortable || this.hasFilter"
      >
        <button
          icon
          lib-icon-btn
          iconType="sort-up"
          (click)="onSortRequest('asc', $event)"
          [ngClass]="{
            active: activeSort === 'asc',
            show: activeSort
          }"
        ></button>

        <button
          icon
          lib-icon-btn
          iconType="sort-down"
          (click)="onSortRequest('desc', $event)"
          [ngClass]="{
            active: activeSort === 'desc',
            show: activeSort
          }"
        ></button>
      </span><!-- End Sort asc-desc icons -->

      <!-- Header text: No-filter applied mode -->
      <ng-container *ngIf="!activeFilter">
        <span
          class="ag-header-cell-text__title"
          (click)="onMenuClicked($event)"
          [ngClass]="{
            'active-filter': activeFilter || activeSort,
            'has-filter': this.colDef.sortable || this.hasFilter
          }" [title]="headerName" >
          {{ headerName }}
        </span>

        <rad-popover 
        *ngIf="params.infoPopoverContent"
        position="top"
        style="padding-left: 4px;"
        popover-append-to="body">
        <rad-icon 
          name="info" 
          size="sm">
          </rad-icon>
          <rad-popover-custom-content>
              <div 
                  style="font-size: 16px; font-weight: 400; line-height: 140%; color: #464247; width: 400px;"
                  [innerHTML]="params.infoPopoverContent"
              ></div>
          </rad-popover-custom-content>
      </rad-popover>

        <span *ngIf="this.hasFilter" (click)="onMenuClicked($event)" class="ag-header-cell-text__filter">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="12px" height="12px" viewBox="0 0 12 12" version="1.1">
            <title>filter</title>
            <g id="filter" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <rect fill="#FFFFFF" x="0" y="0" width="12" height="12"/>
                <path d="M6.57142857,10.8571429 C6.625,10.8571429 6.68080357,10.8459821 6.73883929,10.8236607 C6.91294643,10.7477679 7,10.6160714 7,10.4285714 L7,10.4285714 L7,5.45982143 L10.3013393,2.15848214 C10.4397321,2.02901786 10.4709821,1.87276786 10.3950893,1.68973214 C10.3191964,1.515625 10.1875,1.42857143 10,1.42857143 L10,1.42857143 L1.42857143,1.42857143 C1.24107143,1.42857143 1.109375,1.515625 1.03348214,1.68973214 C0.957589286,1.87276786 0.988839286,2.02901786 1.12723214,2.15848214 L1.12723214,2.15848214 L4.42857143,5.45982143 L4.42857143,8.71428571 C4.42857143,8.83035714 4.47098214,8.93080357 4.55580357,9.015625 L4.55580357,9.015625 L6.27008929,10.7299107 C6.35044643,10.8147321 6.45089286,10.8571429 6.57142857,10.8571429 Z" id="" fill="#656066" fill-rule="nonzero"/>
            </g>
          </svg>
        </span>
      </ng-container>
      <!-- End Header text: No-filter applied mode -->
      <!-- Header text: Filter applied mode -->
      <ng-container *ngIf="activeFilter">
        <lib-popover *ngIf="overflow"
          [popoverLabel]="headerName"
          popoverTriggerEvents="mouseenter:mouseleave"
          popoverPlacement="auto"
          class="ag-header-cell-text__title"
          [ngClass]="{
              'active-filter': activeFilter || activeSort,
              'has-filter': this.colDef.sortable || this.hasFilter
            }"
          (click)="onMenuClicked($event)"
          >
          <span>
            {{ headerName }}
          </span>
        </lib-popover>
        <span
          *ngIf="!overflow"
          class="ag-header-cell-text__title"
          (click)="onMenuClicked($event)"
          [ngClass]="{
            'active-filter': activeFilter || activeSort,
            'has-filter': this.colDef.sortable || this.hasFilter
          }" [title]="headerName" >
          {{ headerName }}
        </span>
      </ng-container><!-- End Header text: Filter applied mode -->
      <!-- End Header text -->

      <!-- Clear sort/filter icon -->
      <span class="ag-header-cell-text__sort-drop">
        <button
          *ngIf="this.colDef.sortable || this.hasFilter"
          icon
          lib-icon-btn
          iconType="close"
          (click)="onDropFiltersSort($event)"
        ></button>
      </span><!-- End Clear sort/filter icon -->
    </span>
    <span
      ref="eFilter"
      class="ag-header-icon ag-filter-icon ag-hidden"
      aria-hidden="true"
    >
      <span class="ag-icon ag-icon-filter" unselectable="on"></span>
    </span>
  </div>
</div>
